import {
	PagedMultiSelectField,
	SelectDefaultOption,
	laravelServiceSelectFetchConfig,
	withOptionsEndpoint,
} from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { PreferenceOptionResource } from "../types/preference";

const service = withOptionsEndpoint<PreferenceOptionResource>(["preferences"]);
const fetchConfig = laravelServiceSelectFetchConfig(service);

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

const ParentText = styled.small`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	margin-left: 0.25rem;
`;

export const PreferenceMultiSelectField: FC<Props> = (props) => {
	return (
		<PagedMultiSelectField
			{...props}
			fetchConfig={fetchConfig}
			renderOption={(preference, isSelected, isHovered) => (
				<SelectDefaultOption $isSelected={isSelected} $isHovered={isHovered}>
					{preference.name}
					{preference.parent && <ParentText>({preference.parent.name})</ParentText>}
				</SelectDefaultOption>
			)}
		/>
	);
};
